import LineItemColumnKind from './lineItemColumnKind';

export const lineItemVisibilityOrder: LineItemColumnKind[] = [];

export default lineItemVisibilityOrder;
